import React, { useState } from 'react';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';

const fieldOptions = [
  {
    label: 'Market Share of Units Sold',
    id: 'unitsSold',
    fieldName: 'unitsSold',
    marketShareKey: ['unitsSold_sum_value', 'unitsSold_sum_value']
  },
  {
    label: '1P Market Share of Units Sold',
    id: 'onePUnitsSold/unitsSold',
    fieldName: 'onePUnitsSold',
    marketShareKey: ['onePUnitsSold_sum_value', 'unitsSold_sum_value']
  },
  {
    label: '1P Market Share of 1P Units Sold',
    id: 'onePUnitsSold/onePUnitsSold',
    fieldName: 'onePUnitsSold',
    marketShareKey: ['onePUnitsSold_sum_value', 'onePUnitsSold_sum_value']
  },
  {
    label: '3P Market Share of Units Sold',
    id: 'threePUnitsSold',
    fieldName: 'threePUnitsSold',
    marketShareKey: ['threePUnitsSold_sum_value', 'unitsSold_sum_value']
  },
  {
    label: '3P Market Share of 3P Units Sold',
    id: 'threePUnitsSold/threePUnitsSold',
    fieldName: 'threePUnitsSold',
    marketShareKey: ['threePUnitsSold_sum_value', 'threePUnitsSold_sum_value']
  }
];

const AtlasV2UnitsSoldMarketShareOfMultipleSelectSplineChart = () => {
  const [selectedFieldName, setSelectedFieldName] = useState('unitsSold');
  const defaultFieldObj = fieldOptions.find((option) => option.id === selectedFieldName);

  return (
    <AtlasV2ComparableSplineChart
      fieldName={defaultFieldObj.fieldName}
      indexName="sales"
      metricTypeDisplay={METRICTYPE.PERCENT}
      singleDropdownProps={{
        defaultLabel: 'Market Share of Units Sold',
        options: fieldOptions,
        selectedId: selectedFieldName,
        onChange: (option) => {
          setSelectedFieldName(option.id);
        }
      }}
      marketShareKey={defaultFieldObj.marketShareKey}
      marketShareBuilder={(rb) => {
        switch (selectedFieldName) {
          case 'unitsSold':
          case 'threePUnitsSold/threePUnitsSold':
            return rb.removeConditionTermFilters((termFilter) => termFilter.fieldName === 'brandId');

          case 'onePUnitsSold/unitsSold':
          case 'threePUnitsSold':
            return rb
              .modifyAggregation((agg) =>
                agg.removeAggregationField('onePUnitsSold').addAggregationField('unitsSold', 'unitsSold', 'sum', true)
              )
              .removeConditionTermFilters((termFilter) => termFilter.fieldName === 'brandId');
          case 'onePUnitsSold/onePUnitsSold':
            return rb
              .modifyAggregation((agg) =>
                agg
                  .removeAggregationField('unitsSold')
                  .addAggregationField('One P Units Sold', 'onePUnitsSold', 'sum', true)
              )
              .removeConditionTermFilters((termFilter) => termFilter.fieldName === 'brandId');
          default:
            break;
        }

        return rb;
      }}
    />
  );
};

export default AtlasV2UnitsSoldMarketShareOfMultipleSelectSplineChart;
